import { memoize } from '@/lib/memoize';
import type { PartialUser, State, User } from './types';

export type Mutation = setLoaded | setUsers | updateUser | addUser;
type setLoaded = {
  type: 'setLoaded';
  value: boolean;
};
type setUsers = {
  type: 'setUsers';
  users: User[];
};
type updateUser = { type: 'updateUser'; user: PartialUser };
type addUser = { type: 'addUser'; user: User };

const mutations = {
  setLoaded,
  setUsers,
  updateUser,
  addUser,
};

export function reducer(state: State, action: Mutation): State {
  const method: number = 1;
  if (method === 1) {
    const mutation = mutations[action.type] as (
      state: State,
      action: unknown,
    ) => State;
    if (!mutation) {
      return state;
    }

    return mutation(state, action);
  } else if (method === 2) {
    switch (action.type) {
      case 'setLoaded':
        return setLoaded(state, action);
      case 'setUsers':
        return setUsers(state, action);
      case 'addUser':
        return addUser(state, action);
      case 'updateUser':
        return updateUser(state, action);
    }
  }

  return state;
}

function setLoaded(state: State, action: setLoaded) {
  return { ...state, loaded: action.value };
}

function setUsers(state: State, action: setUsers) {
  return { ...state, loaded: true, users: memoize(action.users) };
}

function updateUser(state: State, action: updateUser) {
  const existing = state.users[action.user.id];
  const updated = {
    id: existing.id,
    data: {
      ...existing.data,
      ...action.user.data,
    },
  };
  const users = { ...state.users, [existing.id]: updated };

  return {
    ...state,
    users,
  };
}

function addUser(state: State, action: addUser) {
  return {
    ...state,
    users: { ...state.users, [action.user.id]: action.user },
  };
}
